import { ListFilter, Check } from 'lucide-react'
import { Button } from '../../lib/shadcn/button'
import { Checkbox } from '../../lib/shadcn/checkbox'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../lib/shadcn/popover'
import { cn } from '../../lib/shadcn/utils'
import { PIPELINE_STATUS_OPTIONS } from '../../utils/interviews'

export function StatusFilter({
  selected,
  onChange,
}: {
  selected: string[]
  onChange: (next: string[]) => void
}) {
  const isAll = selected.length === 0
  const label = isAll
    ? 'All stages'
    : selected.length === 1
      ? '1 stage'
      : `${selected.length} stages`

  const toggle = (code: string) => {
    if (selected.includes(code)) onChange(selected.filter((c) => c !== code))
    else onChange([...selected, code])
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-9 flex-1 justify-start gap-2 font-normal">
          <ListFilter className="h-4 w-4 text-muted-foreground" />
          <span className="truncate">{label}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-1">
        <button
          type="button"
          onClick={() => onChange([])}
          className={cn(
            'flex w-full items-center justify-between rounded-sm px-2 py-1.5 text-sm hover:bg-accent',
            isAll && 'font-medium text-foreground',
          )}
        >
          All stages
          {isAll && <Check className="h-4 w-4 text-[hsl(var(--brand))]" />}
        </button>
        <div className="my-1 h-px bg-border" />
        <div className="max-h-72 overflow-y-auto">
          {PIPELINE_STATUS_OPTIONS.map((opt) => {
            const checked = selected.includes(opt.code)
            return (
              <label
                key={opt.code}
                className="flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent"
              >
                <Checkbox checked={checked} onCheckedChange={() => toggle(opt.code)} />
                <span className="flex-1 text-foreground">{opt.label}</span>
              </label>
            )
          })}
        </div>
      </PopoverContent>
    </Popover>
  )
}
